// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"306":"learner-dashboard-main","569":"instructor-dashboard-main"}[chunkId] || chunkId) + "." + {"306":"aeb261f82a98fde4f0cc","569":"523add0293776373d9bb","710":"09037801df538e379e53"}[chunkId] + ".js";
};